export default "__VITE_ASSET__87df0974__"